import axios from "axios";
import { extractError } from "../utils/apiErrorUtils";
import { sendAsOneAction } from "../utils/idempotencyKey";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const getMyThreads = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/chat`);
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to load conversations"));
  }
};

export const getOrCreateThread = async (otherUserId, tradeRequestId) => {
  try {
    const body = { otherUserId };
    if (tradeRequestId) body.tradeRequestId = tradeRequestId;
    const { data } = await axios.post(`${apiUrl}/chat`, body);
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to start conversation"));
  }
};

export const getThread = async (threadId, { limit, before } = {}) => {
  try {
    const params = new URLSearchParams();
    if (limit) params.set("limit", limit);
    if (before) params.set("before", before);
    const qs = params.toString();
    const { data } = await axios.get(`${apiUrl}/chat/${threadId}${qs ? `?${qs}` : ""}`);
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to load conversation"));
  }
};

export const sendMessage = async (threadId, text, attachment) => {
  try {
    const body = { text };
    if (attachment) body.attachment = attachment;
    // Retrying the same unsent message reuses its key, so a send whose reply
    // was lost is not stored twice (B-16). One slot for the one chat box:
    // ChatPage forgets it whenever the box is edited, so only a re-send of the
    // untouched draft counts as a retry.
    const { data } = await sendAsOneAction(
      "chat",
      JSON.stringify([threadId, body]),
      (headers) => axios.post(`${apiUrl}/chat/${threadId}/messages`, body, { headers })
    );
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to send message"));
  }
};

// It runs on its own (open, poll, return to the app) and every caller swallows
// its failure, so a refusal raises no toast (B-31). An outage still does.
export const markThreadRead = async (threadId) => {
  try {
    const { data } = await axios.put(`${apiUrl}/chat/${threadId}/read`, null, { quietRefusal: true });
    return data;
  } catch (error) {
    return Promise.reject(extractError(error, "Failed to mark as read"));
  }
};
